import { observer } from 'mobx-react-lite'
import { useEffect, useMemo } from 'react'
import { EnumSpinnerLoaderPosition, type IRow, SpinnerLoader, Table } from 'shared/ui'
import { NoResultsFound } from 'shared/ui/NoResultsFound/NoResultsFound'
import { type History } from 'pages/contacts/pages/history/model/History'
import { getHistoryActions } from 'pages/contacts/pages/history/helpers/historyActions'
import { useHistoryColumnNames } from 'pages/contacts/pages/history/helpers/useHistoryColumnNames'
import { useHistoryPageContext } from 'pages/contacts/pages/history/context/historyPageContext'
import styles from './styles.module.scss'

export const ContactHistoryTable = observer(() => {
  const contactsHistoryStore = useHistoryPageContext()
  const {
    totalHistory,
    historyData,
    pagination,
    isLoading,
    isNoImportsYet,
    changePagination,
    scrollToTOpTrigger,
    dispose,
  } = contactsHistoryStore

  useEffect(() => {
    return () => {
      dispose()
    }
  }, [])

  const rows = useMemo(
    (): IRow<History>[] =>
      historyData.map((history) => {
        history.setActionsProps &&
          history.setActionsProps({
            showItems: 0,
            actions: getHistoryActions(history, contactsHistoryStore),
            noVisibleActions: true,
          })

        return history
      }),
    [historyData]
  )

  const columns = useHistoryColumnNames(contactsHistoryStore)

  if (isNoImportsYet) {
    return <NoResultsFound label='No imports found' />
  }

  return (
    <div className={styles.tableContainer}>
      {isLoading && (
        <SpinnerLoader
          ariaLabel={'ContactHistoryTable'}
          position={EnumSpinnerLoaderPosition.Absolute}
        />
      )}

      <Table
        ariaLabel={'ContactHistoryTable'}
        virtualization
        sxBox={{ padding: '0 16px' }}
        columns={columns}
        rows={rows}
        rowsCount={totalHistory}
        limit={pagination.limit}
        initPage={pagination.page}
        scrollToTOpTrigger={scrollToTOpTrigger}
        onChangePagination={(page: number, pageSize: number) => {
          changePagination(page, pageSize)
        }}
        rightHeaderContent={<div />}
      />
    </div>
  )
})
